import { lazyGettext } from '@eb/lazy-gettext';
import { PACKAGE_ONE, PACKAGE_THREE, PACKAGE_TWO } from '../../constants/main';
import { STYLE_ANCHOR } from '@eb/eds-button';

export default {
    [PACKAGE_ONE]: {
        CTAs: [
            lazyGettext('Your Current Package'),
            lazyGettext('Upgrade'),
            lazyGettext('Contact Us'),
        ],
        CTAStyles: [null, STYLE_ANCHOR, STYLE_ANCHOR],
    },
    [PACKAGE_TWO]: {
        CTAs: [
            lazyGettext('Downgrade'),
            lazyGettext('Your Current Package'),
            lazyGettext('Contact Us'),
        ],
        CTAStyles: [STYLE_ANCHOR, null, STYLE_ANCHOR],
    },
    [PACKAGE_THREE]: {
        CTAs: [
            lazyGettext('Downgrade'),
            lazyGettext('Downgrade'),
            lazyGettext('Your Current Package'),
        ],
        CTAStyles: [STYLE_ANCHOR, STYLE_ANCHOR, null],
    },
};
